/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SkuStockQueryReqDTO { 
    page?: number;
    size?: number;
    sortBy?: string;
    ascending?: boolean;
    /**
     * Product code
     */
    spuCode?: string;
    /**
     * Product name
     */
    spuName?: string;
    /**
     * SKU code
     */
    skuCode?: string;
    /**
     * SKU name
     */
    skuName?: string;
    /**
     * SKU status on Lazada
     */
    status?: Array<SkuStockQueryReqDTO.StatusEnum>;
}
export namespace SkuStockQueryReqDTO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        DraftPublished: 'DRAFT_PUBLISHED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


